import { Pipe, PipeTransform } from '@angular/core';
import { displayCaptureStatus } from 'app/core/options/capture-status.opts';

@Pipe({ name: 'captureStatus' })
export class CaptureStatusPipe implements PipeTransform {
  transform = displayCaptureStatus
}
